'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function AssessmentDoneAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-json/assessment-done-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="AssessmentDoneAnimation"
    />
  );
}
